import { render, staticRenderFns } from "./ProductUploadImage.vue?vue&type=template&id=cf2e9ec6"
import script from "./ProductUploadImage.vue?vue&type=script&lang=js"
export * from "./ProductUploadImage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports